import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';
import { Button } from '@/components/common';
import { logger } from '@/lib';

export function RouteErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError();

  useEffect(() => {
    logger.error('[RouteErrorPage]', { error });
  }, [error]);

  return (
    <div className="flex h-screen items-center justify-center bg-admin-bg">
      <div className="text-center">
        <p className="text-lg font-medium text-admin-text mb-1">{t('errors.title')}</p>
        <p className="max-w-md text-sm text-admin-text-secondary mb-6">{t('errors.description')}</p>
        <Button onClick={() => window.location.reload()}>{t('errors.reloadPage')}</Button>
      </div>
    </div>
  );
}
